module.exports = __webpack_public_path__ + "static/media/screenshot2.5b328de8.png";